export default __webpack_public_path__ + "images/O2.20eba7c.png";